import * as React from "react";
import { Skeleton } from "@grandvisionhq/iris-ui";
import { ProductBlockGrid } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
/* empty css                            */
const ProductListingSkeleton = ({ pageSize }) => {
  const { getLabel } = useIntl();
  const skeletonGrid = React.useMemo(
    () => Array.from({ length: pageSize }).map((_, i) => /* @__PURE__ */ React.createElement(ProductBlockGrid.Cell, { key: `skeleton-cell-${i}` }, /* @__PURE__ */ React.createElement("div", { className: "product-listing-skeleton-loader" }, /* @__PURE__ */ React.createElement(
      Skeleton,
      {
        height: 220,
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel("common.loadingText")
      },
      /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100", rx: "5", fill: "currentColor" }),
      /* @__PURE__ */ React.createElement("rect", { width: "80%", height: "15", rx: "5", fill: "currentColor", x: "10%", y: "140" }),
      /* @__PURE__ */ React.createElement("rect", { width: "80%", height: "15", rx: "5", fill: "currentColor", x: "10%", y: "165" }),
      /* @__PURE__ */ React.createElement("rect", { width: "50%", height: "15", rx: "5", fill: "currentColor", x: "25%", y: "200" })
    )))),
    [getLabel, pageSize]
  );
  return /* @__PURE__ */ React.createElement("div", { className: "product-listing-skeleton" }, /* @__PURE__ */ React.createElement(ProductBlockGrid.Grid, null, skeletonGrid));
};
export {
  ProductListingSkeleton,
  ProductListingSkeleton as default
};
//# sourceMappingURL=ProductListingSkeleton.js.map
